'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _validationIcon = require('../../BaseInput/styled/validation-icon');

var _validationIcon2 = _interopRequireDefault(_validationIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _styledComponents2.default)(_validationIcon2.default).withConfig({
  componentId: 's157nz3l-0'
})(['top:-10px;position:relative;']);